import { SponsorState } from "../types/state";
import { RootState } from "../../applicationStore";
import { createSelector } from "@reduxjs/toolkit";
import { TalesSponsor } from "../../../utils/types/TalesSponsor";
import { LOADING } from "../../../types";

export const getSponsorState = (state: RootState): SponsorState =>
  state.sponsor;

export const getSponsorData = createSelector(
  getSponsorState,
  (sponsorState): TalesSponsor[] | null => sponsorState?.data,
);

export const getSponsorError = createSelector(
  getSponsorState,
  (sponsorState): string | null => sponsorState?.error,
);

export const isSponsorLoading = createSelector(
  getSponsorState,
  (sponsorState): boolean => sponsorState?.loading === LOADING.PENDING ?? false,
);
